import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import AbstractImage from '../../images/file-pen-duotone.svg';
import RubriqAbstractStatus from './RubriqAbstractStatus';
var RubriqNoAbstractsMessage = function RubriqNoAbstractsMessage(_ref) {
  var onCreateAbstract = _ref.onCreateAbstract,
    creatingAbstract = _ref.creatingAbstract;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: AbstractImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "make your abstract concrete"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.no-abstracts"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary mt-4",
    disabled: creatingAbstract,
    onClick: function onClick() {
      return onCreateAbstract();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "create abstract"
  }), creatingAbstract && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "ms-1",
    spin: true
  }))), /*#__PURE__*/React.createElement(RubriqAbstractStatus, {
    isNoAbstractsMessage: true
  }));
};
export default RubriqNoAbstractsMessage;